import { Bot, Copy, Sparkles } from "lucide-react";
import type { ReactNode } from "react";
import { toast } from "sonner";
import type { ChatMessage } from "../types";

type Props = {
  message: ChatMessage;
  children: ReactNode;
  wide?: boolean;
};

export function AIChatAssistantFrame({ message, children, wide }: Props) {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(message.text);
      toast.success("Copied");
    } catch {
      toast.error("Could not copy");
    }
  };

  return (
    <div className="flex items-start gap-3">
      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary text-white">
        <Bot className="h-4 w-4" aria-hidden />
      </span>
      <div className="min-w-0 flex-1 space-y-2">
        <div
          className={
            wide
              ? "max-w-full rounded-xl border border-[#E5E7EB] bg-white px-4 py-3 shadow-sm"
              : "max-w-[min(100%,40rem)] rounded-xl border border-[#E5E7EB] bg-white px-4 py-3 shadow-sm"
          }
        >
          <div className="mb-2 flex items-center gap-1.5 text-sm font-medium text-primary">
            {/* <Sparkles className="h-4 w-4" /> */}
            Anthro AI
          </div>
          {children}
        </div>
        <button
          type="button"
          onClick={() => void handleCopy()}
          className="inline-flex items-center gap-1.5 rounded-md border border-[#E5E7EB] bg-white px-2 py-1 text-xs text-[#6B7280] hover:bg-[#F9FAFB]"
        >
          <Copy className="h-3.5 w-3.5" />
          Copy
        </button>
      </div>
    </div>
  );
}
